import { ReactNode } from "react";
import { Box } from "@mui/material";
import { AiPoweredChipGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/AiPoweredChipGraphic";

export const AiPoweredChipWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <Box>
      {children}
      <Box
        sx={{
          position: "absolute",
          top: "10px",
          right: "10px",
        }}
      >
        <AiPoweredChipGraphic sx={{ width: "100%", height: "24px" }} />
      </Box>
    </Box>
  );
};
